<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="ch00_fm01_half"></a><a id="page_1"></a>The<br/>Young Professional’s<br/>Guide to</p>
<p class="halftitle"><strong>MANAGING</strong><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_half.vue?21d2a396